"use strict";

import ActionTypes from '../actions/ActionTypes';
import BaseStore from './BaseStore';
import MigrationStatus from '../types/MigrationStatus';
import {setStoredMigrationRedirectUrl} from '../lib/migrationUtils';

class MigrationStore extends BaseStore {
    _migrationStatus = null;
    _statusLoading = false;
    _migrationSubmitting = false;
    _error = null;
    _redirectUrl = null;

    constructor() {
        super();
        this.subscribe(() => this._registerToActions.bind(this));
    }

    _registerToActions(action) {
        switch (action.type) {
            case ActionTypes.REQUEST_GET_MIGRATION_STATUS:
                if (!action.silent) {
                    this._statusLoading = true;
                }
                this._error = null;
                this.emitUpdate();
                break;

            case ActionTypes.REQUEST_GET_MIGRATION_STATUS_SUCCESS:
                this._statusLoading = false;
                this._migrationStatus = new MigrationStatus({}).fromDTO(action.migrationStatusDTO);
                this._error = null;
                this.emitUpdate();
                break;

            case ActionTypes.REQUEST_GET_MIGRATION_STATUS_ERROR:
                this._statusLoading = false;
                this._error = action.error;
                this.emitUpdate();
                break;

            case ActionTypes.REQUEST_MIGRATION:
                this._migrationSubmitting = true;
                this._error = null;
                this._redirectUrl = null;
                this.emitUpdate();
                break;

            case ActionTypes.REQUEST_MIGRATION_SUCCESS:
                this._migrationSubmitting = false;
                if (action.migrationStatusDTO) {
                    this._migrationStatus = new MigrationStatus({}).fromDTO(action.migrationStatusDTO);
                }
                this._redirectUrl = action.redirectUrl || null;
                // Outlive the session: the Web 9 exit reuses this hand-off URL
                // long after the store has been rebuilt.
                setStoredMigrationRedirectUrl(
                    this._migrationStatus && this._migrationStatus.userName,
                    this._redirectUrl
                );
                this._error = null;
                this.emitUpdate();
                break;

            case ActionTypes.REQUEST_MIGRATION_ERROR:
                this._migrationSubmitting = false;
                this._error = action.error;
                this.emitUpdate();
                break;

            case ActionTypes.SIGN_OUT_USER:
            case ActionTypes.REQUEST_SESSION_TIMEOUT:
                this._migrationStatus = null;
                this._statusLoading = false;
                this._migrationSubmitting = false;
                this._error = null;
                this._redirectUrl = null;
                this.emitUpdate();
                break;

            default:
                break;
        }
    }

    get migrationStatus() {
        return this._migrationStatus;
    }

    get statusLoading() {
        return this._statusLoading;
    }

    get migrationSubmitting() {
        return this._migrationSubmitting;
    }

    get error() {
        return this._error;
    }

    get redirectUrl() {
        return this._redirectUrl;
    }
}

export default new MigrationStore();
